export default __webpack_public_path__ + "static/media/header-image-desktop.0ea4a8d5.jpg";